import { PhoneIcon } from 'assets/icons';
import { telHref } from 'pages/prospection/callListItems';

// Wildix takes the calls: a tel: link hands it the number, through a link
// rather than location.href so that the page stays where it is.
export const dial = (phone) => {
  const href = telHref(phone);
  if (!href) return;
  const link = document.createElement('a');
  link.href = href;
  link.click();
};

// The people that can be called ([{ name, phone }]), each number once.
export const callNumbers = (people) => {
  const seen = new Set();
  return people.filter((person) => {
    const href = telHref(person?.phone);
    if (!href || seen.has(href)) return false;
    seen.add(href);
    return true;
  });
};

/**
 * « Appel » of a record (QuickActions): one number calls it at once in
 * Wildix, several open a menu to pick whom to call, none calls `onNone`.
 */
export const callAction = ({ label, people, onNone }) => {
  const numbers = callNumbers(people);
  const action = { key: 'call', label, icon: PhoneIcon };
  if (!numbers.length) return { ...action, onClick: onNone };
  if (numbers.length === 1) return { ...action, onClick: () => dial(numbers[0].phone) };
  return {
    ...action,
    menu: numbers.map((person) => ({ label: `${person.name} · ${person.phone}`, onClick: () => dial(person.phone) })),
  };
};
